import { render } from "./UpdateQuestion.vue?vue&type=template&id=5898022e&scoped=true"
import script from "./UpdateQuestion.vue?vue&type=script&lang=js"
export * from "./UpdateQuestion.vue?vue&type=script&lang=js"

import "./UpdateQuestion.vue?vue&type=style&index=0&id=5898022e&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5898022e"]])

export default __exports__